import "../styles/main.css";

import { destroyDomScripts, initDomScripts } from "./app";

declare global {
	interface Window {
		faUI?: {
			/** Re-scan after injecting markup (AJAX, editor preview). Idempotent. */
			init: (root?: ParentNode) => Promise<void>;
			/** Detach before replacing markup *in place*; unnecessary when elements are removed. */
			destroy: (root?: ParentNode) => void;
		};
	}
}

const start = () => {
	void initDomScripts();
};

if (typeof window !== "undefined" && typeof document !== "undefined") {
	window.faUI = {
		init: (root?: ParentNode) => initDomScripts(root),
		destroy: (root?: ParentNode) => destroyDomScripts(root),
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start, { once: true });
	} else {
		start();
	}
}

export { destroyDomScripts, initDomScripts };
